'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', '$rootScope',
    function ($scope, $rootScope) {

        $scope.update = update;

        init();

        // region Function

        function init() {
            $rootScope.title = "Сотрудники";

            // инициализация модели
            $scope.filters = [];
            $scope.filter = {
                org: null
            };
            $scope.def = {};

        }

        function update() {
            $scope.filters = [];
            if ($scope.filter.org != null)
                $scope.filters.push("'org.id' EQ '" + $scope.filter.org + "'");
        }

        // endregion

        // region Watcher

        $scope.$watch('filter.org', function () {
            $scope.def.org = null;
            if ($scope.filter.org != null && Array.isArray($scope.orgs))
                $scope.def.org = $scope.orgs.find(o => o.id == $scope.filter.org);
        });

        // endregion

    }];
